package com.vidaensupalabra.vsp.utils

import kotlinx.browser.localStorage

// Funciones para guardar texto persistente en el navegador usando LocalStorage nativo
fun saveToLocalStorage(key: String, value: String) {
    localStorage.setItem(key, value)
}

fun getFromLocalStorage(key: String): String? {
    return localStorage.getItem(key)
}
